import { z } from 'zod';
import { GITHUB_USERNAME_RE } from '../auth/update-me';
import { defineEndpoint } from '../define';
import { UserListItemSchema } from './list';

export const UpdateUserBodySchema = z
  .object({
    // Replace-the-full-set: the user's role set becomes exactly this list.
    roleIds: z
      .array(z.string().uuid())
      .min(1)
      .transform((ids) => [...new Set(ids)])
      .optional(),
    // Admin edit — verified against GitHub like the self-service path; null clears.
    githubUsername: z
      .string()
      .trim()
      .regex(GITHUB_USERNAME_RE, 'Invalid GitHub username')
      .nullable()
      .optional(),
    githubUsernameLocked: z.boolean().optional(),
    // Soft disable/enable; disabled users cannot sign in or use the API.
    disabled: z.boolean().optional(),
    // Reset-only: null replays the first-entry welcome on the user's next visit.
    welcomedAt: z.null().optional(),
  })
  .refine(
    (b) =>
      b.roleIds !== undefined ||
      b.githubUsername !== undefined ||
      b.githubUsernameLocked !== undefined ||
      b.disabled !== undefined ||
      b.welcomedAt !== undefined,
    { message: 'At least one editable field must be present' },
  );

export type UpdateUserBody = z.infer<typeof UpdateUserBodySchema>;

export const UpdateUserResponseSchema = z.object({
  data: UserListItemSchema,
});

export const updateUser = defineEndpoint({
  method: 'PATCH',
  path: '/v1/users/:userId',
  params: z.object({ userId: z.string().uuid() }),
  query: z.object({}),
  body: UpdateUserBodySchema,
  response: UpdateUserResponseSchema,
});
